import { Mixpanel } from "./mixpanel";

const uuid = () => {
  try {
    return crypto.randomUUID();
  } catch (e) {
    return "ff-" + Date.now() + "-" + Math.random().toString(16).slice(2);
  }
};

// A quote request was accepted. Same dataLayer event as the fiberfed.com forms; no personal data.
export const trackQuoteLead = (quoteId, details = {}) => {
  try {
  const eventId = uuid();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "lead", ff_event_id: eventId, ff_form_name: "finder_quote", ff_page: window.location.pathname });
  if (typeof window.fbq === "function") {
    window.fbq("trackSingle", "727523189241522", "Lead", { content_name: "finder_quote" }, { eventID: eventId });
  }
  Mixpanel.track("QUOTE SUBMITTED", { ...details, quote_id: quoteId, ff_event_id: eventId });
  } catch (e) {
    // Tracking must never interrupt the quote.
  }
};
